import { __extends } from "tslib";
import { ValueObject } from '../../base/ddd-types/value-object';
import { getGlobalPadId } from '../../base/utils';
var DocPadInfo = /** @class */ (function (_super) {
    __extends(DocPadInfo, _super);
    function DocPadInfo(jsonObj) {
        var _this = _super.call(this) || this;
        _this.docStatus = 0;
        _this.domainId = '';
        _this.padId = '';
        _this.padType = '';
        _this.type = 0;
        _this.shareLink = '';
        _this.lastModifyTime = 0;
        _this.lastModifyUser = '';
        _this.relative = [];
        _this.jsonObj2Class(jsonObj);
        return _this;
    }
    Object.defineProperty(DocPadInfo.prototype, "globalPadId", {
        get: function () {
            return getGlobalPadId(this.domainId, this.padId);
        },
        enumerable: false,
        configurable: true
    });
    return DocPadInfo;
}(ValueObject));
export { DocPadInfo };
